import React from 'react'
import {
  Card,
  CardContent,
  CardActions,
  Button,
  Typography
} from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faEdit,
  faTrash,
  faEye,
  faCopy
} from '@fortawesome/free-solid-svg-icons'
import PropTypes from 'prop-types'
import { StatusChip } from '../atoms'

const TemplateCard = ({
  template,
  onEdit,
  onDelete,
  onPreview,
  onDuplicate,
  className
}) => {
  return (
    <Card className={className}>
      <CardContent>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
          <Typography variant="h6" style={{ flex: 1 }}>
            {template.name}
          </Typography>
          {template.sendgrid_template_id && (
            <StatusChip label="SendGrid" color="primary" size="small" />
          )}
        </div>
        
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 8 }}>
          Subject: {template.subject}
        </Typography>
        
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 8 }}>
          From: {template.from_email}
        </Typography>
        
        <Typography 
          variant="body2" 
          color="textSecondary"
          style={{ 
            marginBottom: 8,
            maxHeight: 40,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical'
          }}
        >
          {template.body}
        </Typography>
      </CardContent>
      
      <CardActions>
        <Button
          size="small"
          startIcon={<FontAwesomeIcon icon={faEye} />}
          onClick={() => onPreview(template)}
        >
          Preview
        </Button>
        
        <Button
          size="small"
          startIcon={<FontAwesomeIcon icon={faEdit} />}
          onClick={() => onEdit(template)}
        >
          Edit
        </Button>
        
        <Button
          size="small"
          startIcon={<FontAwesomeIcon icon={faCopy} />}
          onClick={() => onDuplicate(template)}
        >
          Duplicate
        </Button>
        
        
        <Button
          size="small"
          color="secondary"
          startIcon={<FontAwesomeIcon icon={faTrash} />}
          onClick={() => onDelete(template.id)}
          style={{ marginLeft: 'auto' }}
        >
          Delete
        </Button>
      </CardActions>
    </Card>
  )
}

TemplateCard.propTypes = {
  template: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onPreview: PropTypes.func.isRequired,
  onDuplicate: PropTypes.func.isRequired,
  className: PropTypes.string
}

export default TemplateCard